import { render, staticRenderFns } from "./logisticsCost.vue?vue&type=template&id=2ccfe6e0&scoped=true&"
import script from "./logisticsCost.vue?vue&type=script&lang=js&"
export * from "./logisticsCost.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCost.vue?vue&type=style&index=0&id=2ccfe6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfe6e0",
  null
  
)

export default component.exports